import { handleNarIngestionApiCall } from "./handleNarIngestionApiCall";

interface HandleApproveNarIngestionParams {
  payerType: string;
  subType: string;
  month: number;
  year: number;
  documentType: string;
  setIsSubmitting?: (isSubmitting: boolean) => void;
  sourceFileName?: string;
  effectiveDate?: string;
  neverExpire?: boolean;
}

export const handleApproveNarIngestion = async ({
  payerType,
  subType,
  month,
  year,
  documentType,
  setIsSubmitting,
  sourceFileName,
  effectiveDate,
  neverExpire = false,
}: HandleApproveNarIngestionParams) => {
  // Call the dynamic API function with ingest=true for approval
  await handleNarIngestionApiCall({
    payerType,
    subType,
    month,
    year,
    documentType,
    ingest: true, // Approval action
    setIsSubmitting,
    sourceFileName,
    effectiveDate,
    neverExpire,
  });
};
